const BASE = (accountId) => `/api/v1/ozon-realization/${accountId}`;

export const triggerRealizationSync = ({ request, accountId }) =>
  request(`${BASE(accountId)}/sync`, { method: 'POST' });

export const getRealizationSyncStatus = ({ request, accountId }) =>
  request(`${BASE(accountId)}/sync-status`);

export const resetRealizationMonth = ({ request, accountId, year, month }) =>
  request(`${BASE(accountId)}/sync/${year}/${month}/reset`, { method: 'POST' });

export const resetAllRealizationMonths = ({ request, accountId }) =>
  request(`${BASE(accountId)}/sync/reset-all`, { method: 'POST' });

export const getRealizationAnalytics = ({ request, accountId }) =>
  request(`${BASE(accountId)}/analytics`);

export const listRealizationPostings = ({ request, accountId, page = 1, perPage = 100, search = '' }) =>
  request(`${BASE(accountId)}/postings?page=${page}&per_page=${perPage}&search=${encodeURIComponent(search)}`);

export const getProjectRealizationAnalytics = ({ request, accountIds }) => {
  const params = accountIds.map((id) => `account_ids=${encodeURIComponent(id)}`).join('&');
  return request(`/api/v1/ozon-realization/project-analytics?${params}`);
};

export const getCustomerOrders = ({ request, accountId, customerId }) =>
  request(`${BASE(accountId)}/customers/${encodeURIComponent(customerId)}/orders`);

export const startOzonChat = ({ request, accountId, postingNumber }) =>
  request(`${BASE(accountId)}/chat/start`, {
    method: 'POST',
    body: JSON.stringify({ posting_number: postingNumber }),
  });

export const sendOzonChatMessage = ({ request, accountId, chatId, text }) =>
  request(`${BASE(accountId)}/chat/send`, {
    method: 'POST',
    body: JSON.stringify({ chat_id: chatId, text }),
  });
